import { useEffect, useState } from 'react';
import userAction from '../actions/userAction';
import { useAuthDispatchContext } from '../../auth/context/authContext';
import storage from '/src/utils/storage';
import hasPermission from '/src/utils/hasPermission';
import NoAccessMessage from '../../auth/components/NoAccessMessage/NoAccessMessage';
import { useNavigate} from 'react-router-dom';
function updateUser({children, permissions = []}) {
    const [isLoaded, setIsLoaded] = useState(false);

    const navigate = useNavigate();
    // Disable the return to enable resfh user each time you change page

    const dispatch = useAuthDispatchContext();
    useEffect( () => {
        var isUserInfo = true;
        const fetchData = async () => {
            // Refetch user + permissions on every page change (not just at
            // login), so a permission revoked/granted elsewhere takes effect
            // on the user's next navigation instead of requiring a re-login.
            const data = await userAction.refreshUserInformation();

            if(!isUserInfo) return;

            if (!data) {
                storage('local').remove('user');
                storage('local').remove('token');
                storage('local').remove('refresh_token');
                dispatch({type : 'loginOut'});
                navigate('/login');
                return;
            }

            const { user, permissions: freshPermissions } = data;
            storage('local').set('user', user);
            storage('session').set('permissions', freshPermissions);
            dispatch({type : 'refreshUserInfo', payload : { user, token : storage('local').get('token')} });

            setIsLoaded(true);
        }

        fetchData().catch((err) => console.error(err));

        return () => isUserInfo = false;
    }, [dispatch]);
    
    if(!isLoaded) {
        return <></>;
    }

    if(permissions.length > 0 && !permissions.some(perm => hasPermission(perm))) {
        return <NoAccessMessage />;
    }

    return children;
}

export default updateUser;